import React, {useEffect} from 'react';
import Header from "../components/Header";

function Impresszum() {
    document.title = "Impresszum"

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return <div className={"content impresszum"}>
        <h1>Impresszum</h1>
        <h3>Az oldal tulajdonosa:</h3>
        <p>Cégnév: HSG-Fémipari Kft.</p>
        <p>Székhely: 4400 Nyíregyháza, Eperjes utca 12. 8. emelet 25.</p>
        <p>Cégjegyzékszám: 15 09 087918</p>
        <p>Adószám: 28833978-2-15</p>
        <p>Telefon: +36 30 480 9842</p>
        <p>E-mail: info@tetoesterkomosas.hu</p>
        <p>Weboldal: www.tetoesterkomosas.hu</p>
        <p>Képviselő: a társaság ügyvezetője</p>
        <h3>Tárhelyszolgáltató:</h3>
        <p>Név: Rackhost Zrt.</p>
        <p>Cím: 1132 Budapest, Victor Hugo utca 18-22.</p>
        <p>Székhely: 6722 Szeged, Tisza Lajos körút 41.</p>
        <p>Elérhetőség: www.rackhost.hu</p>
    </div>
}

export default Impresszum;